import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CasePreviewAuditModels } from '@models/case-preview-audit.model';

export const CasePreviewAuditActions = createActionGroup({
  source: 'Case Preview Audit',
  events: {
    'Reset State': emptyProps(),
    'Load Audit': props<{ filters: CasePreviewAuditModels.RequestFilter }>(),
    'Load Audit Success': props<{ response: CasePreviewAuditModels.Response }>(),
    'Load Audit Fail': emptyProps(),
  },
});
